module.exports = __webpack_public_path__ + "img/baffleTitle.513a0fca.png";